import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Form } from "react-bootstrap";
import { ButtonComponent } from "../../components/elements";
import {
  LabelFieldComponent,
  LabelTextareaComponent,
} from "../../components/fields";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import { BASE_URL, TOKEN, CURRENT_IP } from "../../helper/BASE_URL";

export default function Directs() {
  const [data, setData] = useState([]);

  const { t } = useContext(TranslatorContext);

  useEffect(() => {
    Get_Data();
  }, []);

  const Get_Data = () => {
    const getDta = localStorage.getItem("jwt");
    const parseIT = JSON.parse(getDta);

    try {
      axios
        .post(
          BASE_URL + "get_directs.php",
          {
            userid: parseIT.reg_em,
            token: parseIT.boss_token,
            ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data)
          if (acc.data.data.direct_referrals_list[0].user_id !== "NO RECORDS FOUND") {
            setData(acc.data.data.direct_referrals_list);
          }

        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <PageLayout>
      <div className="mc-card">
        <div className="mc-breadcrumb">
          <h3 className="mc-breadcrumb-title">{t("Directs")}</h3>
          <ul className="mc-breadcrumb-list">
            <li className="mc-breadcrumb-item">
              <Link to="#" className="mc-breadcrumb-link">
                {t("home")}
              </Link>
            </li>
            <li className="mc-breadcrumb-item">{t("Directs")}</li>
          </ul>
        </div>
      </div>
      <div className="mc-card p-sm-5">
        <div className="mc-table-responsive">
          <table className="mc-table">
            <thead className="mc-table-head">
              <tr>
                <th>S.N.</th>
                <th>user id</th>
                <th>name</th>
                <th>mobile number</th>
                <th>user status</th>
                <th>reg date</th>
              </tr>
            </thead>
            <tbody className="mc-table-body">
              {data.map((hit, index) => {
                return (
                  <tr key={index}>
                    <td style={{width:'5%'}}>{index + 1}</td>
                    <td style={{width:'30%',minWidth:'90%'}}>{hit.user_id}</td>
                    <td>{hit.name}</td>
                    <td>{hit.mobile_number}</td>
                    <td style={{width:'10%'}}>{hit.user_status}</td>
                    <td>{hit.reg_date}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {
            data.length == 0 &&
            <p style={{textAlign:"center",marginTop:15,fontWeight:"bolder"}}>No Data Found</p>
          }
        </div>
      </div>
    </PageLayout>
  );
}
